import { render, staticRenderFns } from "./DataAnalysis.vue?vue&type=template&id=377c79f0&scoped=true&"
import script from "./DataAnalysis.vue?vue&type=script&lang=js&"
export * from "./DataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalysis.vue?vue&type=style&index=0&id=377c79f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c79f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377c79f0')) {
      api.createRecord('377c79f0', component.options)
    } else {
      api.reload('377c79f0', component.options)
    }
    module.hot.accept("./DataAnalysis.vue?vue&type=template&id=377c79f0&scoped=true&", function () {
      api.rerender('377c79f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/DataAnalysis.vue"
export default component.exports